

export const brands=[
    {
        "value": "Piaget"
    },
    {
        "value": "Jacob & Co"
    },
    {
        "value": "Cartier"
    },
    {
        "value": "Bibigi"
    },
    {
        "value": "Van Cleef & Arpels"
    },
    {
        "value": "Pomellato"
    },
    {
        "value": "Bvlgari"
    },
    {
        "value": "Pasquale Bruni"
    },
    {
        "value": "ЭПЛ Якутские бриллианты"
    },
    {
        "value": "Chopard"
    },
    {
        "value": "Baraka"
    },
    {
        "value": "Casato"
    },
    {
        "value": "Imma"
    },
    {
        "value": "Faberge"
    },
    {
        "value": "Roberto Coin"
    },
    {
        "value": "Damiani"
    },
    {
        "value": "Carrera y Carrera"
    },
    {
        "value": "De Beers"
    },
    {
        "value": "Audemars Piguet"
    },
    {
        "value": "Mikimoto"
    },
    {
        "value": "Giorgio Visconti"
    },
    {
        "value": "Stephen Webster"
    },
    {
        "value": "Chaumet"
    },
    {
        "value": "Tiffany & Co"
    },
    {
        "value": "Franck Muller"
    },
    {
        "value": "De Grisogono"
    },
    {
        "value": "Mauboussin"
    },
    {
        "value": "Casa Gi"
    },
    {
        "value": "Alfieri & St.John"
    }
]